import { useEffect, useState } from 'react'
import { Phone, Pencil, Trash2, Plus, Contact } from 'lucide-react'
import { Loader } from 'components/loader'
import EmergencyContactForm from './EmergencyContactForm'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { emergencyContactList, delEmergencyContact } from '../../../../redux/slices/help_desk/sos/Sos'
import { deleteHandler } from 'utils'
import { useTranslation } from 'react-i18next'

export default function ConfigurationTab() {

    const [formMode, setFormMode] = useState(null)
    const [editContact, setEditContact] = useState(null)
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const bool = useSelector((state) => state.global.bool)
    const contacts = useSelector((state) => state?.sos?.contacts)
    const loading = useSelector((state) => state?.sos?.loading)

    useEffect(() => {
        dispatch(emergencyContactList({ navigate }))
    }, [bool])

    const openAdd = () => {
        setEditContact(null)
        setFormMode('add')
    }

    const openEdit = (contact) => {
        setEditContact(contact)
        setFormMode('edit')
    }

    const closeForm = () => {
        setFormMode(null)
        setEditContact(null)
    }

    const deleteContact = (id) => {
        deleteHandler({
            title: `${t('sos.contact')} ${t('common.delete')}`,
            text: t('common.confirm_text'),
            cancelbt: t('common.cancel'),
            confirmbt: t('common.delete'),
            itemId: id,
            deleteAction: (id) => dispatch(delEmergencyContact(id)),
            del_title: t('sos.contact'),
            del_text: t('common.delete_text'),
            del_confirmbt: t('common.ok'),
            wrong_toast: t('common.wrong'),
            navigate,
            dispatch,
        })
    }

    if (formMode) {
        return (
            <div className="sos-tab-content">
                <div className="sos-form-panel">
                    <div className="sos-form-panel__head">
                        <span className="sos-form-panel__icon">
                            <Contact size={16} />
                        </span>
                        <h6>{formMode === 'add' ? t('sos.add_contact') : t('sos.edit_contact')}</h6>
                    </div>
                    <EmergencyContactForm contact={editContact} onCancel={closeForm} />
                </div>
            </div>
        )
    }

    return (
        <div className="sos-tab-content">
            <div className="sos-config-head">
                <h6>{t('sos.emergency_contacts')}</h6>
                <button type="button" className="sos-add-btn" onClick={openAdd}>
                    <Plus size={14} />
                    {t('sos.add_contact')}
                </button>
            </div>

            {loading ? (
                <div className="d-flex justify-content-center py-4">
                    <Loader />
                </div>
            ) : contacts?.length > 0 ? (
                <div className="sos-contact-list">
                    {contacts.map((contact) => (
                        <div key={contact?.id} className="sos-contact-card">
                            <div className="sos-contact-info">
                                <div className="sos-contact-name">{contact?.user_name || '-'}</div>
                                <div className="sos-contact-mobile">
                                    <Phone size={13} />
                                    <span>{t('sos.mobile')}: {contact?.user_mobile || '-'}</span>
                                </div>
                            </div>
                            <div className="sos-contact-actions">
                                <button
                                    type="button"
                                    className="sos-edit-btn"
                                    onClick={() => openEdit(contact)}
                                >
                                    <Pencil size={13} />
                                    {t('common.edit')}
                                </button>
                                <button
                                    type="button"
                                    className="sos-delete-btn"
                                    onClick={() => deleteContact(contact?.id)}
                                >
                                    <Trash2 size={13} />
                                    {t('common.delete')}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="sos-empty-note">
                    <span>{t('sos.no_contacts')}</span>
                </div>
            )}
        </div>
    )
}